import { useMutation } from "@tanstack/react-query";
import { Button, Flex, Form, Input, message } from "antd";
import { Content } from "antd/es/layout/layout";
import { FC } from "react";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import { correctSign, wrongSign } from "../../assets/auth/SVGIcons";
import { authChangePassword, authResetPassword } from "../../network/auth";

interface ResetPasswordFormProps {
  token?: string;
  userId?: number;
  handleClosePassword?: any;
}
const length = new RegExp(/.{8,}/);
// const numbers = new RegExp(/^(?=.*[0-9]).*$/);
// const upperCase = new RegExp(/[A-Z]/);
// const lowerCase = new RegExp(/[a-z]/);
const symbols = new RegExp(/^(?=.*[!*@#$%^&+=]).*$/);
const ResetPasswordForm: FC<ResetPasswordFormProps> = ({
  token,
  userId,
  handleClosePassword,
}) => {
  const intl = useIntl();
  const { mutate, isLoading } = useMutation(authResetPassword);
  const { mutate: muteteChangePassword, isLoading: loadChangePassword } =
    useMutation(authChangePassword);
  const [form] = Form.useForm();
  const password = Form.useWatch("password", form);
  const navigate = useNavigate();

  const validatePassword = () => {
    // if (password !== password) {
    //   return false;
    // }
    // if (
    //   !length.test(password) ||
    //   !lowerCase.test(password) ||
    //   !upperCase.test(password) ||
    //   !numbers.test(password) ||
    //   !symbols.test(password)
    // )
    if (!length.test(password) || !symbols.test(password)) {
      return false;
    }
    return true;
  };
  const onFinish = (values: {
    password: string;
    confirmPassword: string;
    password_old?: string;
  }) => {
    if (token) {
      mutate(
        {
          password: values?.password,
          password_confirmation: values?.confirmPassword,
          token,
        },
        {
          onSuccess: (res: any) => {
            if (res?.code !== "ERR_BAD_REQUEST") {
              message.success(intl.formatMessage({ id: "passwordChanged" }));
              navigate("/login");
            } else {
              message.error(res?.response?.data?.message || "حاول مرة اخرى");
            }
          },
        }
      );
    } else {
      muteteChangePassword(
        {
          old_password: values?.password_old,
          password: values?.password,
          password_confirmation: values?.confirmPassword,
          user_id: `${userId}`,
        },
        {
          onSuccess: (res: any) => {
            if (res?.code !== "ERR_BAD_REQUEST") {
              message.success(intl.formatMessage({ id: "passwordChanged" }));
              handleClosePassword();
            } else {
              message.error(res?.response?.data?.message || "حاول مرة اخرى");
            }
          },
        }
      );
    }
  };

  return (
    <div dir="rtl">
      <Form onFinish={onFinish} layout="vertical" form={form} className="">
        {!token ? (
          <Form.Item
            className=""
            name={"password_old"}
            label={intl.formatMessage({ id: "oldPassword" })}
            colon={false}
            required={false}
            hasFeedback
            rules={[
              {
                required: true,
                message: intl.formatMessage({ id: "oldPasswordRequired" }),
              },
            ]}
          >
            <Input.Password />
          </Form.Item>
        ) : null}
        <Form.Item
          className=""
          name={"password"}
          label={intl.formatMessage({ id: "theNewPassword" })}
          colon={false}
          required={false}
          hasFeedback
          rules={[
            {
              required: true,
              message: intl.formatMessage({ id: "enterNewPassword" }),
            },
            {
              validator: (_, value) => {
                if (value && !validatePassword()) {
                  return Promise.reject(
                    new Error(
                      intl.formatMessage({
                        id: "passwordNotMatch",
                      })
                    )
                  );
                } else {
                  return Promise.resolve();
                }
              },
            },
          ]}
        >
          <Input.Password />
        </Form.Item>
        <Form.Item
          className="!mb-2"
          dependencies={["password"]}
          name={"confirmPassword"}
          label={intl.formatMessage({ id: "confirmNewPassword" })}
          colon={false}
          required={false}
          hasFeedback
          rules={[
            {
              required: true,
              message: intl.formatMessage({ id: "enterConfirmPassword" }),
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("password") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error(
                    intl.formatMessage({
                      id: "confirmPasswordNotMatchPassword",
                    })
                  )
                );
              },
            }),
          ]}
        >
          <Input.Password />
        </Form.Item>
        <Content className="my-4">
          <Flex align="center" gap={"8px"}>
            <span className="">
              {password && length.test(password) ? correctSign : wrongSign}
            </span>
            <span className="text-sm text-sec-title ">
              {intl.formatMessage({ id: "8chars/numbers" })}
            </span>
          </Flex>

          {/* <Flex align="center" gap={"8px"}>
            <span className="">
              {password && upperCase.test(password) ? correctSign : wrongSign}
            </span>
            <span className="text-sm text-sec-title">
              تحتوي على حرف كبير على الأقل
            </span>
          </Flex> */}

          {/* <Flex align="center" gap={"8px"}>
            <span className="">
              {password && lowerCase.test(password) ? correctSign : wrongSign}
            </span>
            <span className="text-sm text-sec-title">
              تحتوي على حرف صغير على الأقل
            </span>
          </Flex> */}

          <Flex align="center" gap={"8px"}>
            <span className="">
              {password && symbols.test(password) ? correctSign : wrongSign}
            </span>
            <span className="text-sm text-sec-title">
              {intl.formatMessage({ id: "hasSpecialChar" })}
            </span>
          </Flex>
          {/* <Flex align="center" gap={"8px"}>
            <span className="">
              {password && numbers.test(password) ? correctSign : wrongSign}
            </span>
            <span className="text-sm text-sec-title">تحتوي على رقم</span>
          </Flex> */}
        </Content>
        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            loading={userId ? loadChangePassword : isLoading}
            className="w-full my-2"
          >
            {intl.formatMessage({ id: "submit" })}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default ResetPasswordForm;
